import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommCheckCircleIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25ZM1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25C6.06294 1.25 1.25 6.06294 1.25 12Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M16.658 7.64014C16.8568 8.00356 16.7233 8.45928 16.3599 8.65803C14.9313 9.43925 13.6154 11.0543 12.628 12.5663C12.1434 13.3083 11.755 13.9986 11.4879 14.5032C11.3545 14.7552 11.2519 14.9599 11.1831 15.1005C11.1488 15.1707 11.1229 15.2249 11.1059 15.2609L11.0872 15.3008L11.0829 15.31L11.0821 15.3118C10.9662 15.5651 10.7194 15.7335 10.4413 15.7489C10.1631 15.7642 9.89937 15.6241 9.75635 15.385C9.42332 14.8282 8.90302 14.3319 8.43485 13.9618C8.2056 13.7805 7.99926 13.6376 7.85153 13.5409C7.77787 13.4926 7.71935 13.4562 7.68053 13.4326C7.66114 13.4208 7.64671 13.4122 7.63783 13.407L7.62874 13.4017C7.62874 13.4017 7.74293 13.2007 8 12.75L8.37156 12.0985C8.01176 11.8933 7.55372 12.0186 7.34851 12.3784C7.14335 12.7382 7.26912 13.1964 7.62874 13.4017M10.2671 13.6053C10.5431 13.0944 10.9171 12.4428 11.372 11.7462C12.3846 10.1957 13.8687 8.31075 15.6401 7.34197C16.0036 7.14323 16.4593 7.27672 16.658 7.64014M10.2671 13.6053C9.96032 13.2805 9.64262 13.0045 9.36515 12.7851C9.0944 12.571 8.85074 12.4022 8.67347 12.2861C8.58463 12.2279 8.5119 12.1826 8.46009 12.1511C8.43417 12.1353 8.41344 12.123 8.3985 12.1142L8.38049 12.1036L8.37486 12.1004L8.37292 12.0993L8.37156 12.0985C8.37156 12.0985 8.37156 12.0985 8 12.75"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
